import { render, staticRenderFns } from "./TimePressureTest.vue?vue&type=template&id=1a4a492b&"
import script from "./TimePressureTest.vue?vue&type=script&lang=js&"
export * from "./TimePressureTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports